// extracted by mini-css-extract-plugin
export default {"wrapper":"Mention_wrapper__ztbhC","text":"Mention_text__3Gaf-","modal":"Mention_modal__2p3do"};